(function () {
    'use strict';

    angular.module('blocks.notification', [
        'ngAnimate',
        'pascalprecht.translate',
        'toastr'
    ]);
})();
